export const decodeOtherLanguage = function (strToDecode) {
    const result = decodeURIComponent(escape(window.atob(strToDecode)));
    return result === 'null'?'':result;
};


export const showEmbedFooter = function() {
    const url = new URL(window.location);
    let showEmbedFooter = false;
    if (url) {
      const params = new URLSearchParams(url.search);
      if (params) {
        showEmbedFooter = (params.get("embed") && params.get("embed") === 'true')?true:false;
        console.log('showFooter ', showEmbedFooter);
      }
    }
    return showEmbedFooter;
  };


export const getUrlWord = function (urlPath, hash = null) {
  // [hash removal] remove this after hash migration
  if (hash && hash != '') {
    return hash.replace(/(^#)/g, "");
  }
  let urlArray = urlPath.split('/');
  if (urlArray[1] && urlArray[1] != '' && urlArray[2] && urlArray[2] != '') {
    return `/${urlArray[1]}/${urlArray[2]}`;
  }
  console.log('window', '__CURL_' + window.location.hostname.replace(/\./g, "_"));
  return '__CURL_' + window.location.hostname.replace(/\./g, "_");
};

export const getTippingUserSelections = function (idComp) {
  let localContext = `${idComp}-`;
  return localStorage.getItem(localContext + 'tippingUserSelections')
          && JSON.parse(localStorage.getItem(localContext + 'tippingUserSelections'));
}

export const isValidJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const getGlobalCode = (code) => {
  if (code && code != '') {
    return window.atob(code);
  } else {
    return '';
  }
}

export const injectGlobalCode = ($, htmlTag, code) => {
  if (code && code != '' && code.trim().length > 0) {
    var targetHtmlElement = $(htmlTag);
    if (targetHtmlElement) {
      targetHtmlElement.append(code);
    }
  }
}

export const increaseTransparencyByPercent = (input, percent = 40) => {
  // let input = 'rgba(255, 255, 255, 0.5)';
  let trans = 1;
  let m = input.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
  if(m && m[4] && m[4] < 1) {
    trans = parseFloat(m[4]) + (parseFloat(m[4]) * (percent/100));
    return `rgba(${m[1]},${m[2]},${m[3]},${trans < 1 ? trans : 1})`;
  }
  return input;
}
